import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBtOutboundArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.3134 2.94568L11.8118 3.36756C11.6958 3.38162 11.6466 3.52399 11.7292 3.60661L12.7733 4.64899L8.00615 9.41793C6.59118 10.8557 4.76587 12.8679 3.09647 14.4406C3.07029 14.4671 3.05561 14.5028 3.05561 14.5399C3.05561 14.5771 3.07029 14.6128 3.09647 14.6393L3.891 15.4303C3.91743 15.4564 3.95312 15.4711 3.99031 15.4711C4.02751 15.4711 4.0632 15.4564 4.08963 15.4303L9.74803 9.7754C10.8851 8.65635 12.3921 6.91992 13.7665 5.64215L14.8089 6.68454C14.8276 6.70312 14.8511 6.7161 14.8768 6.72198C14.9025 6.72786 14.9293 6.72642 14.9542 6.71781C14.9791 6.7092 15.0011 6.69378 15.0177 6.67329C15.0342 6.6528 15.0447 6.62807 15.048 6.60192L15.4698 3.10037C15.4821 3.01072 15.4048 2.93338 15.3134 2.94568Z",
		fill: "#26292E"
	})
});
export default SvgBtOutboundArrow;
